<template>
	<bsh-modal 
		titulo="Efetuar Pagamento"
		:name="name">
		<template v-slot:default>
	        <receita-form
	        	:dados="dados" 
	        	:name="name" 
	        	:errors="errors"
	        	:pedido="pedido">
	        </receita-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import Receita from "./../../models/Receita.js";
	export default {
		props:['pedido'],
		data(){
			return {
				dados: new Receita(),
				name: 'create_receita',
				errors: []
			}
		}, 
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
				if(this.pedido){
					this.dados['pedido_id'] = this.pedido;
				}
	            axios.post(this.$url+'/api/adm/receita/store', (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new Receita()
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
		},
	}
</script>